/*
 * Kunstmühle Hofmeir – Schnellbestellung (sections/km-quick-order.liquid).
 * Mengen je Gebinde eintragen, Summe/Gewicht mitrechnen, alles auf einmal in den Warenkorb.
 * Das Einlegen übernimmt window.kmAddItems aus km-relaunch.js.
 */
(function () {
  const fmtEur = (cents) => (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  const fmtKg = (grams) =>
    (grams / 1000).toLocaleString('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + ' kg';

  const readLast = () => {
    try {
      const last = JSON.parse(localStorage.getItem('km-cart-last'));
      return last && Array.isArray(last.items) ? last.items : [];
    } catch (e) {
      return [];
    }
  };

  class KmQuickOrder extends HTMLElement {
    connectedCallback() {
      if (this.kmBound) return;
      this.kmBound = true;
      this.inputs = Array.from(this.querySelectorAll('[data-km-quick-qty]'));
      this.summary = this.querySelector('[data-km-quick-summary]');
      this.submit = this.querySelector('[data-km-quick-submit]');
      this.error = this.querySelector('[data-km-quick-error]');

      this.addEventListener('click', (event) => {
        const step = event.target.closest('[data-km-quick-step]');
        if (step) {
          const input = step.parentElement.querySelector('[data-km-quick-qty]');
          this.setQty(input, this.qty(input) + Number(step.dataset.kmQuickStep));
          return;
        }
        if (event.target.closest('[data-km-quick-submit]')) this.add();
        if (event.target.closest('[data-km-quick-last]')) this.applyLast();
      });
      this.addEventListener('input', (event) => {
        if (event.target.matches('[data-km-quick-qty]')) this.update();
      });
      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-km-quick-qty]')) this.setQty(event.target, this.qty(event.target));
      });

      // „Mengen vom letzten Einkauf übernehmen“ nur, wenn davon etwas in der Liste steht
      this.last = readLast().filter((item) => this.inputFor(item.id));
      const lastButton = this.querySelector('[data-km-quick-last]');
      if (lastButton) lastButton.hidden = this.last.length === 0;
      this.update();
    }

    inputFor(variantId) {
      return this.inputs.find((i) => Number(i.dataset.variantId) === Number(variantId) && !i.disabled);
    }

    qty(input) {
      const n = parseInt(input.value, 10);
      return Number.isNaN(n) ? 0 : n;
    }

    setQty(input, value) {
      input.value = String(Math.min(99, Math.max(0, value)));
      this.update();
    }

    applyLast() {
      this.inputs.forEach((input) => (input.value = '0'));
      this.last.forEach((item) => {
        const input = this.inputFor(item.id);
        if (input) input.value = String(Math.min(99, Number(item.q) || 0));
      });
      this.update();
    }

    selected() {
      return this.inputs
        .filter((input) => !input.disabled && this.qty(input) > 0)
        .map((input) => ({
          id: Number(input.dataset.variantId),
          q: this.qty(input),
          t: input.dataset.title,
          v: input.dataset.variantTitle,
          price: Number(input.dataset.price) || 0,
          weight: Number(input.dataset.weight) || 0,
        }));
    }

    update() {
      const items = this.selected();
      this.inputs.forEach((input) => input.closest('.km-quick__variant').classList.toggle('is-active', this.qty(input) > 0));
      if (!this.summary) return;
      if (!items.length) {
        this.summary.textContent = 'Noch nichts ausgewählt';
        this.submit.disabled = true;
        return;
      }
      const count = items.reduce((sum, i) => sum + i.q, 0);
      const grams = items.reduce((sum, i) => sum + i.q * i.weight, 0);
      const cents = items.reduce((sum, i) => sum + i.q * i.price, 0);
      const parts = [`${count} ${count === 1 ? 'Packung' : 'Packungen'}`];
      if (grams > 0) parts.push(fmtKg(grams));
      parts.push(fmtEur(cents));
      this.summary.textContent = parts.join(' · ');
      this.submit.disabled = false;
    }

    async add() {
      const items = this.selected();
      if (!items.length || typeof window.kmAddItems !== 'function') return;
      this.submit.disabled = true;
      this.submit.classList.add('loading');
      this.error.textContent = '';
      const result = await window.kmAddItems(items, { source: 'km-quick-order' });
      this.submit.classList.remove('loading');
      if (result.added) this.inputs.forEach((input) => (input.value = '0'));
      if (result.missing) this.error.textContent = `Gerade nicht verfügbar: ${result.missing}`;
      this.update();
      if (result.added && this.summary) this.summary.textContent = '✓ Liegt im Warenkorb';
    }
  }

  if (!customElements.get('km-quick-order')) customElements.define('km-quick-order', KmQuickOrder);
})();
